module.exports = __webpack_public_path__ + "img/dashboard-bg.802e1a70.png";